import { capitalizeFirstLetter } from "./capitalizeFirstLetter";
import { getLowerCaseThreeCharPeriodLabel } from "./getPeriodAbbreviation";

export const mapDataForDailyOccupancy = (
  data: { [key: string]: number },
  period: string
) => {
  const periodLabel = getLowerCaseThreeCharPeriodLabel(period);

  const dataByPeriod = Object.entries(data).reduce((acc, [key, value]) => {
    const [day, period] = key.split("_");
    if (!acc[period]) {
      acc[period] = [];
    }
    acc[period].push({
      Day_of_week: capitalizeFirstLetter(day.slice(0, 3)),
      occupancy_rate: value,
    });
    return acc;
  }, {} as Record<string, { Day_of_week: string; occupancy_rate: number }[]>);

  return dataByPeriod[periodLabel];
};
